import React from 'react'

import { Text } from 'Components/UI'

import { HEADER_NAV_LINKS } from './constants'
import { StyledLink } from './styles'

function HeaderNavigation() {
  return (
    <>
      {HEADER_NAV_LINKS.map(item => (
        <StyledLink href={item.href} key={item.id}>
          <Text as="span" body14 semiLight>
            {item.label}
          </Text>
        </StyledLink>
      ))}
    </>
  )
}

export default HeaderNavigation
